export default __webpack_public_path__ + "static/media/gallery-wip-pommel_01.053df09e.jpg";